import { Shark } from "shark-mvc";
import BaseContent from "./BaseContent";

class PlaceContent extends BaseContent {
	description = "";
	coordsLat = "";
	coordsLon = "";
	hierarchy = [];
	type = "place";

	__descriptionAbstract = "";

	_mainEditorField = "description";
	
	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.hierarchy = this.exportArrayField("hierarchy");
		
		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		this.parseDescription();
	}

	onDescriptionChanged () {
		this.parseDescription();
	}

	parseDescription () {
		// this.__descriptionAbstract = this.description.length > 35 ? this.description.slice(0, 35) + "..." : this.description;
		const htmlStrippedDescription = this.description.replace(/<[^>]*>/g, "");
		this.__descriptionAbstract = htmlStrippedDescription.length > 50 ? htmlStrippedDescription.slice(0, 50) + "..." : htmlStrippedDescription;
	}
}

Shark.registerModel("PlaceContent", PlaceContent);

export default PlaceContent;